export const parseTimeFromDatetime = (datetime: string): string => {
  if (!datetime) return '12:00';
  if (datetime.includes('T')) {
    return datetime.split('T')[1]?.substring(0, 5) || '12:00';
  }
  return datetime.substring(0, 5) || '12:00';
};

export const parseDateFromDatetime = (datetime: string): string => {
  if (!datetime) return '';
  if (datetime.includes('T')) {
    return datetime.split('T')[0];
  }
  return datetime;
};
